import { generateTotals } from './generateTotals';
import { ICDV3ViewItem } from '../interfaces/ICDViewItem';
import { ICDViewItemSection } from '../interfaces/ICDV3ItemSection';

export const generateSection = (items?: ICDV3ViewItem[] | null): ICDViewItemSection | null => {
  return items
    ? {
        items,
        totals: generateTotals(items),
      }
    : null;
};
